import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { ContactTemp } from './contact-temp.model';
import { ContactTempService } from './contact-temp.service';

@Component({
    selector: 'jhi-contact-temp-detail',
    templateUrl: './contact-temp-detail.component.html'
})
export class ContactTempDetailComponent implements OnInit, OnDestroy {

    contactTemp: ContactTemp;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private contactTempService: ContactTempService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['contactTemp', 'contactType', 'contactStatus']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInContactTemps();
    }

    load(id) {
        this.contactTempService.find(id).subscribe((contactTemp) => {
            this.contactTemp = contactTemp;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInContactTemps() {
        this.eventSubscriber = this.eventManager.subscribe('contactTempListModification', (response) => this.load(this.contactTemp.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/contact-temp-detail.component.ts